const HISTORY_KEY = "search-history";
const MAX_HISTORY = 10;

export const getHistory = () => {
  try {
    return JSON.parse(localStorage.getItem(HISTORY_KEY)) || [];
  } catch {
    return [];
  }
};

const saveHistory = (items) => {
  localStorage.setItem(HISTORY_KEY, JSON.stringify(items.slice(0, MAX_HISTORY)));
};

export const addToHistory = (item) => {
  const prev = getHistory().filter((h) => h.id !== item.id);
  saveHistory([{ ...item, timestamp: Date.now() }, ...prev]);
};

export const removeFromHistory = (id) => {
  saveHistory(getHistory().filter((h) => h.id !== id));
};
